import { lang } from '@/legacy/lib//lang';

export function isTab (route) {
    return this.$route.params.tab === route;
}

export function rgba (varname, opacity)
{
  /*
  if (!isNaN (varname)) {
    varname = [
        "red", "blue", "teal", "purple", "yellow", "orange",
        "green", "pink", "grey", "light-blue", "dark-green",
        "brown", "maroon", "navy", "turquoise", "violet",
        "wheat", "peach", "mint", "lavender", "coal", "snow",
        "emerald", "peanut"
    ] [varname] || varname;
  }
  */

  return `rgba(var(${varname.toLowerCase ()}), ${opacity || 1})`;
}

export function codeToColour (code)
{
  return lang (`colour.${code}`);
}

export function capitalize (camelCase)
{
    let spaced;

    camelCase = '' + camelCase;

    if (!camelCase.length) {
      return camelCase;
    }

    spaced = camelCase.replace (/([^A-Z])([A-Z]|(?:[0-9]+[A-Za-z]))/g, "$1 $2");
    spaced = spaced [0].toUpperCase () + spaced.substring (1);

    return spaced;
}

/**
 * https://stackoverflow.com/questions/118241/calculate-text-width-with-javascript
 */
export function getTextWidth (text, font) {
  // re-use canvas object for better performance
  var canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement ('canvas'));
  var context = canvas.getContext ("2d");

  context.font = font;

  var metrics = context.measureText (text);

  return metrics.width;
}

export function metaFactory (props)
{
  let meta = {
    meta: []
  };

  if (props.title) {
    meta.title = props.title;

    meta.meta = meta.meta.concat ([
      { vmid: 'og:title', name: 'og:title', content: props.title },
      { vmid: 'twitter:title', name: 'twitter:title', content: props.title }
    ]);
  }

  if (props.description) {
    meta.meta = meta.meta.concat ([
      { vmid: 'description', name: 'description', content: props.description },
      { vmid: 'og:description', name: 'og:description', content: props.description },
      { vmid: 'twitter:description', name: 'twitter:description', content: props.description }
    ]);
  }

  if (props.noindex) {
    meta.meta = meta.meta.concat ([
      { vmid: 'robots', name: 'robots', content: 'noindex' }
    ]);
  }

  return meta;
}

export function hex (n)
{
  return ('' + n).match (/.{2}/g).join (' ');
  // let mask = 0xFF;
  // let bytes = [];
  // let byte;

  // for (let i = 0; i < 4; i++) {
  //   byte = (n & (mask << i * 8)) >> (i * 8);

  //   bytes.unshift (
  //     byte
  //       .toString (16)
  //       .padStart (2, '0')
  //   );
  // }

  // return bytes
  //   .join (' ');
}

export function pluralize (n, message)
{
  return n === 1 ? message : `${message}s`;
}

export function battleTag (tag)
{
  let idx = tag.indexOf ('#');

  if (idx === -1) {
    return tag;
  }

  return tag.substring (0, idx);
}

export function battleId (tag)
{
  let idx = tag.indexOf ('#');

  if (idx === -1) {
    return '';
  }

  return tag.substring (idx + 1);
}